// カセットに表示する店舗の数
export const VISIBLE_SHOP_NUMBER_SP = 1;
export const VISIBLE_SHOP_NUMBER_PC = 3;

// イベント周り
export const GA_WORK_LINK = "search_job-cassette";
export const GA_WORK_ENTRY = "search_entry";
export const GA_WORK_KEEP = "search_keep";
export const GA_WORK_SCOUT = "search_scout_entry";
export const GA_SHOP_WORK_LINK = "search_job_inner_cassette-button";
export const GA_SHOW_MODAL_BUTTON = "search_modal";
export const GA_SHOW_MODAL_BUTTON_IN_VIEW = "modal_open_show";
export const GA_MODAL_SHOP_WORK_LINK = "search_job_inner_cassette";
export const GA_MODAL_SHOP_WORK_ENTRY = "search_job_inner_cassette_entry";
export const GA_MODAL_SHOP_WORK_SCOUT_LINK = "search_job_scout_inner_cassette";
export const GA_MODAL_SHOP_WORK_SCOUT_ENTRY = "search_job_scout_inner_cassette_entry";
